import { LOG_OUT } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const logout = (): AppAction => ({
  type: LOG_OUT,
  payload: {}
})